export { default as ArrayListRenderer } from './ArrayListRenderer.vue';

import { entry as arrayListRendererEntry } from './ArrayListRenderer.vue';

export const arrayRenderers = [
  arrayListRendererEntry
]
